import { useInstance } from 'intact-vue';
import { inArray } from './useChecked';
import { toggleArray } from '../utils';
export function useExpandable() {
  var instance = useInstance();
  function isExpanded(key) {
    return inArray(instance.get('expandedKeys'), key);
  }
  instance.on('clickRow', function (data, index, key) {
    if (instance.get('rowExpandable')) {
      var _instance$get = instance.get(),
        expandedKeys = _instance$get.expandedKeys,
        $blocks = _instance$get.$blocks;
      if (!$blocks || !$blocks.expand) return;
      instance.set('expandedKeys', toggleArray(expandedKeys, key));
    }
  });
  return {
    isExpanded: isExpanded
  };
}